export const convertToPercent = (value, total) => {
  if (!value || !total) return 0;
  return (Number(value) / Number(total)) * 100;
};

export const generateRandomNumber = () => {
  return Math.random() * Date.now();
};

export const toReadableNumber = (value) => {
  if (!value) return 0;
  if (isNaN(value)) return value;
  return Number(Number(value).toFixed(2)).toLocaleString();
};

export const formatMetric = (value) => {
  if (value >= 1e9) {
    return (value / 1e9).toFixed(2) + 'B';
  } else if (value >= 1e6) {
    return (value / 1e6).toFixed(2) + 'M';
  } else if (value >= 1e3) {
    return (value / 1e3).toFixed(2) + 'K';
  }
  return value.toString();
};
